import { Page } from 'layouts/Page';
import { FC } from 'react';
import { PpwrLayout } from 'components/EprPpwr/PpwrLayout';
import { PpwrManualReport } from 'components/EprPpwr/PpwrManualReport';

export const PpwrManualReportPage: FC = () => {
	return (
		<Page title="Filing Manual Reports – EPR/PPWR – EAS Dashboard">
			<PpwrLayout>
				<PpwrManualReport />
			</PpwrLayout>
		</Page>
	);
};
